import type { MediaErrorCode } from '@/store/interviewStore'

// Map a getUserMedia rejection to a language-neutral code the UI can localize.
// DOMException names per spec: NotAllowedError (user/policy denied),
// NotFoundError / OverconstrainedError (no matching device),
// NotReadableError / AbortError (device present but unusable, e.g. taken by
// another app). SecurityError is grouped with permission_denied because the
// user-facing remedy is the same (check browser/site permissions).
export function classifyGetUserMediaError(err: unknown): MediaErrorCode {
  const name = err instanceof DOMException ? err.name : ''
  if (name === 'NotAllowedError' || name === 'PermissionDeniedError' || name === 'SecurityError') {
    return 'permission_denied'
  }
  if (name === 'NotFoundError' || name === 'DevicesNotFoundError' || name === 'OverconstrainedError') {
    return 'no_device'
  }
  if (name === 'NotReadableError' || name === 'TrackStartError' || name === 'AbortError') {
    return 'device_busy'
  }
  return 'unknown'
}
